var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.inputTab)?_c('sms-verification-input',{attrs:{"toggle-tab":_vm.toggleTab,"set-phone":_vm.setPhone}}):_vm._e(),(_vm.codeTab)?_c('sms-verification-code',{attrs:{"toggle-tab":_vm.toggleTab,"phone":_vm.phone}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }